// Раунд правок №2 (FRONTEND-AUDIT-2026-07-31, находка по lib/apiClient.ts:9-66):
// makeTimeoutError и AbortController/таймер/cleanup были продублированы дословно из
// utils/csrfFetch.ts вместо выноса в общий модуль — задокументированный в проекте класс
// «скопирована ФОРМА эталона, а не СУТЬ» (CLAUDE.md, урок 1 обкатки 2026-07-29).
//
// Этот файл — тот самый «третий модуль»: ни от кого не зависит (в т.ч. не импортирует
// lib/apiClient.ts), поэтому его можно подключать и туда, и в csrfFetch.ts без цикла
// (csrfFetch.ts импортирует getCsrfToken ИЗ apiClient.ts — обратная связь создала бы цикл).
//
// ГРАНИЦА этой правки (раунд №2, зона FE-REST): utils/csrfFetch.ts вне списка файлов
// зоны — трогать нельзя. Сведён на этот модуль пока только lib/apiClient.ts; миграция
// csrfFetch.ts на те же примитивы — отдельная правка в зоне, владеющей этим файлом,
// иначе один и тот же таймаут-бюджет продолжит жить в двух местах и может разъехаться
// при следующей правке одного из них.

export const makeFetchTimeoutError = (input: RequestInfo | URL, budgetMs: number): Error => {
  const seconds = Math.round(budgetMs / 1000);
  const err = new Error(
    `Сервер не ответил за ${seconds} с — запрос прерван по таймауту. Повторите попытку.`
  );
  err.name = 'TimeoutError';
  (err as Error & { url?: string }).url = String(input).slice(0, 200);
  return err;
};

// Строит AbortSignal, который срабатывает и на внешней отмене (`external`), и по истечении
// `budgetMs`, плюс cleanup/isTimedOut — сам fetch() и его заголовки/credentials остаются
// заботой вызывающего транспорта, это делает помощник переиспользуемым между ними.
export const composeTimeoutSignal = (
  external: AbortSignal | undefined,
  budgetMs: number
): { signal: AbortSignal | undefined; cleanup: () => void; isTimedOut: () => boolean } => {
  if (budgetMs <= 0) {
    return { signal: external, cleanup: () => {}, isTimedOut: () => false };
  }

  const controller = new AbortController();
  let timedOut = false;
  let onExternalAbort: (() => void) | undefined;
  if (external) {
    if (external.aborted) controller.abort();
    else {
      onExternalAbort = () => controller.abort();
      external.addEventListener('abort', onExternalAbort);
    }
  }

  const timer = setTimeout(() => {
    timedOut = true;
    controller.abort();
  }, budgetMs);

  const cleanup = () => {
    clearTimeout(timer);
    if (external && onExternalAbort) external.removeEventListener('abort', onExternalAbort);
  };

  return { signal: controller.signal, cleanup, isTimedOut: () => timedOut };
};
